<template>
    <div class="container">
        <h2 class="titre-section mb-3">
            <span class="span-background">
                Nos pôles de formation
            </span>
        </h2>
        <div class="bloctitleText text-center mb-3">
            EMCI vous propose un panel de formations afin de répondre à tous vos enjeux en matière de ressources
            humaines.
        </div>
        <div class="d-flex justify-content-between gap-3">
            <div class="item d-flex gap-4" v-for="pole in listPoleFormation" :key="pole">
                <a :href="`${pole.url}`">
                    <span class="itemTitle text-center">{{ pole.title }}</span>
                    <div class="d-flex align-items-center">
                        <i :class="pole.icon"></i>
                        <div class="d-flex flex-column">
                            <span class="itemDescribe">{{ pole.describe }}</span>
                        </div>
                    </div>
                </a>
            </div>
        </div>
    </div>
</template>
<script setup>
const listPoleFormation = ref([
    {
        title: 'Soft Skills',
        describe: 'Optimiser son travail à distance, Gérer son stress et ses émotions, Coopérer au sein d\'un groupe...',
        icon: 'fa-solid fa-ranking-star me-4',
        url: '/soft-skills'
    },
    {
        title: 'Ressources Humaines et RSE',
        describe: 'Réussir ses entretiens professionnels, Accompagner la montée en compétences, Dialogue social et CSE...',
        icon: 'fa-solid fa-comments me-4',
        url: '/ressources-humaines-rse'
    },
    {
        title: 'Leadership et Management',
        describe: 'Manager à distance, Gérer les situations difficiles, Pratiquer un management...',
        icon: 'fa-solid fa-user-group me-4',
        url: '/leadership-management'
    }
])
</script>
<style scoped>
.container {
    padding: 30px 30px;
}

.titre-section {
    color: var(--accent, #25233E);
    text-align: center;
    font-family: Nunito;
    font-size: 3.125rem;
    /*50 px */
    font-style: normal;
    font-weight: 600;
    line-height: 111.5%;
    letter-spacing: -0.825px;
    text-transform: uppercase;
}

.bloctitleText {
    font-family: Inter;
    font-size: 18px;
    font-style: normal;
    font-weight: 400;
}

.item {
    border-radius: 0.5625rem;
    background: #FFF;
    box-shadow: 0 10px 25px 0 rgba(0, 0, 0, 0.08);
    padding: 40px;
    width: 33%;
}

.item:hover {
    cursor: pointer;
    background: linear-gradient(93deg, #318EC7 9.92%, #E94B54 52.75%, #FAB74B 88.05%);
}

.itemTitle {
    display: flex;
    /* Make .itemTitle a flex container */
    justify-content: center;
    /* Center the content horizontally */
    align-items: center;
    /* Center the content vertically */
    font-family: Nunito;
    font-size: 25px;
    font-style: normal;
    font-weight: 500;
    line-height: 111.5%;
    letter-spacing: -0.51px;
    transition: all 0.4s;
    margin-bottom: 1rem;
    width: 100%;
    /* Ensure it takes the full width of its parent */
}

.itemDescribe {
    font-family: Inter;
    font-size: 16px;
    font-style: normal;
    font-weight: 400;
    line-height: 144%;
    /* 25.92px */
    letter-spacing: 0.72px;
    transition: all 0.4s;
}

.item i {
    font-size: 40px;
    color: #FAB74B;
    transition: all 0.4s;
}

.item:hover i,
.item:hover .itemTitle,
.item:hover .itemDescribe {
    color: white;
}

/*
* Media responsive
*/
@media only screen and (min-width: 300px) and (max-width: 425px) {
    .d-flex {
        flex-direction: column;
        width: 100%;
        padding: 10px 10px;
    }

    h2 {
        font-size: 20px !important;
    }

    p,
    .bloctitleText,
    a,
    a span {
        font-size: 13px !important;
        font-family: Inter !important;
        line-height: normal;
    }

    .itemTitle {
        font-size: 18px;
    }

    .itemDescribe {
        font-size: 14px;
    }

    .item i {
        font-size: 45px;
    }
}

@media only screen and (min-width: 426px) and (max-width: 768px) {
    .d-flex {
        flex-direction: column;
        width: 100%;
        padding: 10px 10px;
    }

    h2 {
        font-size: 20px !important;
    }

    p,
    .bloctitleText,
    a,
    a span {
        font-size: 13px !important;
        font-family: Inter !important;
        line-height: normal;
    }

    .itemTitle {
        font-size: 18px;
    }

    .itemDescribe {
        font-size: 14px;
    }

    .item i {
        font-size: 45px;
    }
}


@media only screen and (min-width: 769px) and (max-width: 991px) {}

/* Pour les appareils entre 992px et 1199px de large (tablettes en mode portrait et ordinateurs portables) */
@media only screen and (min-width: 992px) and (max-width: 1199px) {
    .container {
        max-width: 95% !important;
        padding: 80px 0px;
    }

    .item i {
        font-size: 35px;
    }

    .itemTitle {
        font-family: Nunito;
        font-size: 20px;
    }
}

/* Pour les appareils de 1200px de large et plus (ordinateurs de bureau) */
@media only screen and (min-width: 1200px) {}

/** ecran 1280 * 1024  */

@media screen and (min-width: 1088px) and (max-width: 1381px) {
    .item i {
        font-size: 25px;
    }

    .itemTitle {
        font-size: 1.625rem;
    }

    .item {
        padding: 25px;
    }
}
</style>